import { MomentInput } from "moment";
import { zDoxItem } from "../../../shared/types";


export type MetadataFormMode = "selectType" | "setProperties";

/**
 * ชื่อฟอร์ม Metadata ที่ user สามารถเลือกได้จาก dropdown menu
 * 
 * Examples:
 * ```
 * { "name": "idex:demo_po", "title": "Purchase Order" }
 * { "name": "idex:weed_doc", "title": "แจ้งการครอบครองกัญชา" }
 * ```
 */
export type MetadataFormType = {
   name: string;
   title: string;
};

/** 
 * All input fields in a Metadata Form
 */
export type MetadataFormProperty = {
   /** Field name. Examples: "idex:job_first_name", "idex:job_education" */
   name: string;
   /** Field label (that the users see). Examples: "ชื่อ", "การศึกษา", "เบอร์โทรศัพท์" */
   label: string;
   /** Field input type. Examples: "text", "int"*/
   type: string;
   /** If true, this field must be filled before saving. */
   mandatory: boolean;
   /**
    * If this field has a dropdown menu, this is the list of values in the dropdown menu.\
    * Example: ["มัธยมศึกษาตอนปลาย", "อนุปริญญา", "ปริญญาตรี", "ปริญญาโท", "ปริญญาเอก"]
    */
   listValue?: string[];
   /** Constraints applied to the input field */
   constraints?: {
      minValue?: number;
      maxValue?: number;
      minLength?: number;
      maxLength?: number;
      expression?: string | RegExp;
   };
   /** Value of the input field */
   value?: MomentInput;
};

export type InfoPanelConfig = {
   tabs?: {
      details: InfoPanel_Details;
      comments: InfoPanel_Comments;
      metadata: InfoPanel_Metadata;
   }
   enableInfoPanel?: boolean;
}

export type InfoPanel_Details = {
   enableDetailsTab?: boolean;
   description?: {
      description: string;
      showDescription?: boolean;
      canEdit?: boolean;
   }
   properties?: {
      owner: string;
      created: string;
      modified: MomentInput;
      type: string;
      /** file size (in byte) */
      size: number;
      location: string;
   }
}

export type InfoPanel_Comments = {
   enableCommentsTab?: boolean;
   comments?: zDoxItem["comments"] | any;
   canAdd?: boolean;
   canEdit?: boolean;
   canDelete?: boolean;
}

export type InfoPanel_Metadata = {
   enableMetadataTab?: boolean;
   mode?: MetadataFormMode;
   formType?: MetadataFormType;
   typeOptions?: MetadataFormType[];
   properties?: MetadataFormProperty[];
   canEdit?: boolean;
}

export const defaultConfig: InfoPanelConfig = {
   tabs: {
      details: {
         enableDetailsTab: true,
         description: {
            description: "",
            showDescription: true,
            canEdit: true,
         },
         properties: {
            owner: "",
            created: "",
            modified: "",
            type: "",
            size: NaN,
            location: "",
         }
      },
      comments: {
         enableCommentsTab: true,
         comments: [],
         canEdit: true,
         canDelete: true,
      },
      metadata: {
         enableMetadataTab: true,
         formType: undefined,
         properties: [],
         canEdit: true,
      },
   },
   enableInfoPanel: true,
}